import { Link, useLocation } from "react-router-dom";
import { Camera, Leaf, MessagesSquare, UserRound, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const tabs = [
  { to: "/", label: "Analisi", icon: Camera, id: "home" },
  { to: "/piante", label: "Le mie piante", icon: Leaf, id: "plants" },
  { to: "/consulenze", label: "Consulenze", icon: MessagesSquare, id: "consultations" },
  { to: "/profilo", label: "Profilo", icon: UserRound, id: "profile" },
];

export default function Layout({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items = user?.role === "professional" ? [...tabs, { to: "/pro", label: "Area Dott.ssa", icon: ShieldCheck, id: "pro" }] : tabs;
  const active = (to) => (to === "/" ? pathname === "/" || pathname.startsWith("/analisi") : pathname.startsWith(to));

  return (
    <div className={`app-shell ${pathname === "/" ? "app-shell-wide" : ""}`}>
      <header className="app-header" data-testid="app-header">
        <Link to="/" className="flex items-center gap-2" data-testid="header-home-link">
          <span className="brand-mark"><Leaf size={16} /></span>
          <span className="font-serif text-lg tracking-wide">Medico delle Piante</span>
        </Link>
        <span className="text-[10px] uppercase tracking-[0.2em] text-[#C9A96E]">Agronomia</span>
      </header>
      <main className="app-main" id="app-scroll" data-testid="app-scroll">{children}</main>
      <nav className="bottom-nav" data-testid="bottom-nav">
        {items.map(({ to, label, icon: Icon, id }) => (
          <Link key={to} to={to} data-testid={`nav-${id}`} className={`nav-item ${active(to) ? "nav-item-active" : ""}`}>
            <Icon size={20} strokeWidth={1.6} />
            <span>{label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
}
